"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const resolvers_1 = require("./resolvers");
const reporter_1 = __importDefault(require("../reporter"));
const constants_1 = require("../constants");
const IGNORE_FIELD_TYPES = ['button', 'submit', 'output', 'hidden'];
const addFieldMetaToModelIds = (models, modelIds, meta, input, repeatIndex) => {
    modelIds.forEach(({ index, id }) => {
        const modelItem = models[index][id];
        if (modelItem.meta) {
            reporter_1.default.error({
                'Model element type': modelItem[constants_1.MODEL_TYPE],
                'Model element name attribute': modelItem.name,
                'Input field ID': input.id,
                'Input field label': input.label,
                'Input field bind': input.bind,
                'Input field bind index': input.bindIndex,
                'Input field type': input.type,
                'Repeat index': repeatIndex,
            });
            throw new Error('Two fields are looking at the same modelItem.');
        }
        modelItem.meta = {};
        Object.entries(meta).forEach(([key, value]) => {
            if (value !== undefined) {
                modelItem.meta[key] = value;
            }
        });
    });
};
const recursiveMoveFieldDetailsToModel = (inputs, models, groupModelIds) => {
    inputs.forEach(input => {
        if (input.type === 'group') {
            recursiveMoveFieldDetailsToModel(input.inputs, models, input.modelRef && input.modelRef.modelIds);
            return;
        }
        if (input.type === 'repeat') {
            let repeatIndex = 1;
            let repeatIndexReturnsModelIds = true;
            while (repeatIndexReturnsModelIds) {
                // eslint-disable-next-line no-loop-func
                input.inputs.forEach(repeatInput => {
                    if (IGNORE_FIELD_TYPES.includes(repeatInput.type)) {
                        return;
                    }
                    const modelIds = (0, resolvers_1.tryResolveModelIds)({
                        models,
                        modelRef: repeatInput.modelRef,
                        repeatIndex,
                    });
                    if (!modelIds.length) {
                        repeatIndexReturnsModelIds = false;
                        return;
                    }
                    addFieldMetaToModelIds(models, modelIds, {
                        fieldValueAttr: repeatInput.modelRef.attr || constants_1.MODEL_CONTENTS,
                        fieldType: repeatInput.type,
                        validators: repeatInput.validators,
                        updates: repeatInput.onChange,
                    }, repeatInput, repeatIndex);
                });
                repeatIndex += 1;
            }
            return;
        }
        if (input.modelRef && !IGNORE_FIELD_TYPES.includes(input.type)) {
            if (Array.isArray(input.modelRef)) {
                input.modelRef.forEach(({ attr, modelIds, filter }, index) => {
                    // https://icg360.atlassian.net/browse/MGRMODS-2787
                    // We can't evaluate dynamic references at this time
                    // instead, ignore them
                    if (filter) {
                        if (index === 0) {
                            reporter_1.default.error("Dynamic references can't be used as the first reference in a field");
                        }
                        return;
                    }
                    addFieldMetaToModelIds(models, modelIds, {
                        fieldValueAttr: attr || constants_1.MODEL_CONTENTS,
                        fieldType: input.type,
                        validators: input.validators,
                        updates: input.onChange,
                        groupModelIds,
                    }, input);
                });
            }
            else {
                if (input.modelRef.filter) {
                    reporter_1.default.error("Dynamic references can't be used as the only reference in a field");
                    return;
                }
                addFieldMetaToModelIds(models, input.modelRef.modelIds, {
                    fieldValueAttr: input.modelRef.attr || constants_1.MODEL_CONTENTS,
                    fieldType: input.type,
                    validators: input.validators,
                    updates: input.onChange,
                    groupModelIds,
                }, input);
            }
            // TODO: uncomment to trim form after PPQ-7612 is complete
            // delete input.validators;
            // delete input.onChange;
        }
    });
};
const moveFieldDetailsToModel = ({ forms, models }) => {
    forms.forEach(({ groups = [] }) => {
        groups.forEach(({ inputs }) => {
            recursiveMoveFieldDetailsToModel(inputs, models);
        });
    });
};
exports.default = moveFieldDetailsToModel;
//# sourceMappingURL=move-field-details-to-model.js.map